import React from "react";
import { RCCButton, RCCTooltip } from "react-common-components";
import CheckPermission from "src/components/CheckPermission";
import List from "src/components/List";
import { useAuth } from "src/context/Auth/context";
import { PermissionEnum } from "src/context/Auth/interface";
import { useTranslation } from "src/context/Translations/context";
import { IPerspectives } from "./interface";
import { WrapperPerspectives, TitlePerspectives } from "./styles";

const Perspectives: React.FC<IPerspectives> = ({
	metba002,
	metbe002,
	refModalitem,
	permissions,
	loadData
}) => {

	const { translate } = useTranslation();
	const { administrator, superUser } = useAuth();

	const colDelete = (row: any) => (
		<>
			<CheckPermission minimumPermissionRequired={PermissionEnum.CREATE_UPDATE_DELETE}>
				{(permissions >= 2 || administrator || superUser) && (
					<RCCTooltip
						color="red"
						text={translate("Excluir")}
						position="left"	
					>
						<RCCButton
							icon={{name: "trash", color: "#FFF", size: 12}}
							color="red"
							size="xs"
							layout="isRounded"
							onClick={(e) => {e.stopPropagation();  refModalitem.current?.actionButtonDelete(true, row.mee002Id, row.mea003Nome, {}, loadData); }}
						/>
					</RCCTooltip>
				)}	
			</CheckPermission>
		</>
	);

	return (
		<>
			<WrapperPerspectives>	
				<TitlePerspectives color={metba002.mea002Cor}>
					{metba002.mea002Nome}
				</TitlePerspectives>
				<List 
					data={metbe002} 
					showHeader
					columns={[{
						idColumn: "mea003Nome",
						nameColumn: translate("Objetivo"),
						justify: "left",
						xs: 11,
						sm: 11,
						truncate: true
					}, {
						idColumn: "",
						nameColumn: "",
						justify: "right",
						xs: 11,
						sm: 11,
						cellRenderer: colDelete
					}]}		
					layout="table"			
				/>
			</WrapperPerspectives>
		</>
	);
};

export default Perspectives;
